/**
 * Created by xiongw on 2019/3/7.
 */
export default {
    alexa: {
        tcl_assitant: "Habilitar habilidad - TCL Assistant",
        active_code_hint: "Introduzca el código de activación",
        active_code_placeholder: "Código de activación",

        active_code_message: "En su televisor TCL, pulse el botón Ajustes",
        active_code_message_path: " en su mando a distancia, diríjase a 'Sistema' > 'Works with Alexa'",
        active_code_message_part2: "y seleccione 'Iniciar sesión' u 'Obtener código' para recibir el código de activación.",

        active_code_message_old: "Vaya a ",
        active_code_message_path_old: "Ajustes/Sistema/Amazon Alexa/Obtener código ",
        active_code_message_part2_old: "en el TV e introduzca el siguiente código de activación.",

        active_code_error_null: "El campo de código no puede estar vacío",
        active_code_error_number: "Introduzca los números",
        active_code_error_bits: "El código debe contener seis dígitos numéricos",
        active_code_validate: "Activar",
        active_code_message_wrong: "El código de activación es incorrecto o ha caducado. Solicite otro.",
        active_code_message_exception: "Compruebe su red y vuelva a intentarlo.",
        check_agreements_message: "Debe aceptar todos los acuerdos para utilizar TCL Assistant.",
        agreements: [
            "Acepto la política de privacidad de TCL",
            "Acepto la ",
            " de TCL."
        ],
        privacy_policy: "política de privacidad",

        grant_hint: "Autorice a TCL a realizar las operaciones.",
        grant_message_success: "Autorización concedida correctamente.",
        grant_message_fail: "Fallo de autorización, vuelva a introducir el código de activación.",
        grant_allow: "Permitir",

        console_welcome_prompt: "Bienvenido a TCL Alexa Console",
        empty_message: "",
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/locale/lang/es.js
// module id = null
// module chunks = 